import React, { useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import { Form, Formik } from "formik";
import TextBox from "../../common/TextBox";
import Button from "../../common/Button";
import { useNavigate, useSearchParams } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";
import { PAGE_STATE } from "../../../constants";

import { ReactComponent as LockSvg } from "../../../assets/icons/lock.svg";
import { toast } from "react-toastify";
import Expired from "./Expired";
import AppContext from "../../../AppContext";
import { langComponent } from "../../../constants";

const ChangePassword = ({ onSuccess }) => {
  const [searchParams] = useSearchParams();
  const [pageState, setPageState] = useState(PAGE_STATE.LOADING);
  const [passwordResetInfo, setPasswordResetInfo] = useState(undefined);
  const { getPasswordReset, resetPassword } = useAuth();
  const [isExpired, setIsExpired] = useState(false);
  const { getLang } = useContext(AppContext);
  const Translation = getLang(langComponent.auth);
  const TranslationCommon = getLang(langComponent.common);
  const navigate = useNavigate();

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    try {
      const id = searchParams.get("id");

      if (!id) {
        toast.error("Invalid link!", {});
        navigate("/");
        return;
      }

      const resetPassword = await getPasswordReset(id);

      if (
        resetPassword.expired ||
        new Date() >= new Date(resetPassword.expiredOn)
      ) {
        toast.error("Link has Expired!", {});
        setIsExpired(true);
        setPageState(PAGE_STATE.IDLE);
        return;
      }

      setPasswordResetInfo(resetPassword);
      setPageState(PAGE_STATE.IDLE);
    } catch (error) {
      toast.error("Unable to reset password!", {});
      setPageState(PAGE_STATE.ERROR);
    }
  };

  const handleSubmit = async ({ password }, options) => {
    try {
      await resetPassword(
        passwordResetInfo.user,
        password,
        passwordResetInfo._id
      );
      toast.success("Update password success");
      onSuccess();
    } catch (error) {
      toast.error("Unable to update password!", {});
      setPageState(PAGE_STATE.ERROR);
    }
  };

  // * Render
  if (pageState === PAGE_STATE.ERROR) {
    return <>Invalid Link!</>;
  }

  if (pageState !== PAGE_STATE.IDLE) {
    return <>Loading</>;
  }

  if (isExpired) {
    return <Expired />;
  }

  return (
    <div className="change-password">
      <h1 className="change-password__header">
        {Translation("Enter new password")}
      </h1>
      <Formik
        initialValues={{ password: "", confirmPassword: "" }}
        validate={({ password, confirmPassword }) => {
          let errors = {};

          if (!password)
            errors.password = Translation("Password cannot be blank");
          if (!confirmPassword)
            errors.confirmPassword = Translation("Password cannot be blank");

          if (password && confirmPassword && password !== confirmPassword) {
            errors.password = "";
            errors.confirmPassword = Translation("Password don't match");
          }

          return errors;
        }}
        onSubmit={handleSubmit}
      >
        <Form className="change-password__form">
          <TextBox
            name="password"
            label={Translation("Password")}
            placeholder={Translation("Password")}
            type="password"
            leadingIcon={<LockSvg />}
          />
          <TextBox
            name="confirmPassword"
            label={Translation("Confirm Password")}
            placeholder={Translation("Confirm Password")}
            type="password"
            leadingIcon={<LockSvg />}
          />
          <Button
            type="submit"
            label={TranslationCommon("Confirm")}
            style={{ marginTop: "36px", width: "100%" }}
          />
        </Form>
      </Formik>
    </div>
  );
};

ChangePassword.propTypes = {
  onSuccess: PropTypes.func,
};

ChangePassword.defaultProps = {
  onSuccess: () => {},
};

export default ChangePassword;
